function getMobileAppVersion(userAgent: string = navigator.userAgent): string {
  const regex = /com\.vio\.mobileapp\s+(\d+\.\d+\.\d+(-\w+)*)/
  const match = userAgent.match(regex)
  return match ? match[1] : ''
}

export {getMobileAppVersion}
